import React, {useCallback} from 'react';
import {Avatar, Menu} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import ListItemIcon from "@mui/material/ListItemIcon";
import VpnKeyTwoToneIcon from '@mui/icons-material/VpnKeyTwoTone';
import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import {HeaderStyle} from "../../../styles/components/HeaderStyle";
import {getAccountInfo} from "../../../utils/GenericUtils";
import {authLogout} from "../../../services/AuthServices";
import moment from "moment";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";
import {useHistory} from "react-router-dom";


const Profile = ({anchorEl, open, handleClose, handleOpenChangePassword, userMode = false}) => {
	const classes = HeaderStyle();
	const history = useHistory();
	const account = getAccountInfo() || {};

	const logout = useCallback(() => {
		authLogout();
	}, []);

	const goToProfileSettings = useCallback(() => {
		handleClose(null);
		history.push("/gestione/profilo");
	}, [handleClose, history]);

	const openPasswordDialog = useCallback(() => {
		handleClose(null);
		handleOpenChangePassword();
	}, [handleClose, handleOpenChangePassword]);

	return (
        <Menu
			className={classes.menu}
			classes={{paper: classes.profileMenuPaper}}
			PaperProps={{
				className: classes.profileMenuPaper,
				elevation: 0
			}}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			keepMounted
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			open={open}
			onClose={() => handleClose(null)}
		>
			<div className={classes.profileHeader}>
				<Avatar className={classes.large}>
					<SVG src={multiavatar(account.username || "atlantis")}/>
				</Avatar>
				<Typography className={classes.profileName} variant="subtitle1">
					{account.alias || account.username || "Atlantis"}
				</Typography>
				{!userMode && (
					<Typography className={classes.profileMeta}>
						{account.username || "--"}
						<br/>
						{account.dataRegistrazione ? moment(account.dataRegistrazione).format("DD/MM/YYYY HH:mm") : ""}
						<br/>
						Gruppo {account.gruppo || "--"}
					</Typography>
				)}
			</div>

			<MenuItem className={classes.profileMenuItem} onClick={goToProfileSettings} disabled={false}>
				<ListItemIcon>
					<ManageAccountsRoundedIcon fontSize="small"/>
				</ListItemIcon>
				<Typography variant="inherit">Profilo</Typography>
			</MenuItem>
			<MenuItem className={classes.profileMenuItem} onClick={openPasswordDialog}>
				<ListItemIcon>
					<VpnKeyTwoToneIcon fontSize="small"/>
				</ListItemIcon>
				<Typography variant="inherit">Cambia password</Typography>
			</MenuItem>
			<MenuItem className={classes.profileMenuItem} onClick={logout}>
				<ListItemIcon>
					<LockTwoToneIcon fontSize="small"/>
				</ListItemIcon>
				<Typography variant="inherit">Logout</Typography>
			</MenuItem>
		</Menu>
    );
}

export default React.memo(Profile);
